import React, { useRef } from 'react';
import {
  Drawer,
  DrawerBody,
  DrawerCloseButton,
  DrawerContent,
  DrawerFooter,
  DrawerHeader,
  DrawerOverlay,
  Button,
  ButtonGroup,
  VStack,
} from '@chakra-ui/react';
import { AppAccessField } from 'features/user-groups/components/CreateTeamDrawer/components';
import { useAddAppsToMember } from '../hooks/useAddAppsToMember';
import { useDrawerStateDispatch } from 'features/main/context';

export const AddAppsToMemberDrawer: React.FC = () => {
  const initialFocusRef = useRef<HTMLInputElement>(null);
  const [{ drawerVisible, drawerId }] = useDrawerStateDispatch();
  const {
    handleSubmit,
    isSubmitting,
    productAccessState,
    setProductAccessState,
    handleCloseDrawer,
    existingApps,
  } = useAddAppsToMember();

  const isOpen = drawerVisible && drawerId === 'add-apps-to-member-drawer';

  return (
    <Drawer
      isOpen={isOpen}
      onClose={handleCloseDrawer}
      initialFocusRef={initialFocusRef}
      size='lg'
    >
      <DrawerOverlay />
      <form onSubmit={handleSubmit} data-testid='add-apps-to-member-form'>
        <DrawerContent data-testid='add-apps-to-member-drawer'>
          <DrawerHeader display='flex' alignItems='center'>
            Add apps
            <DrawerCloseButton />
          </DrawerHeader>
          <DrawerBody>
            <VStack spacing={6} align='stretch'>
              <AppAccessField
                tenantList={existingApps}
                productAccessState={productAccessState}
                setProductAccessState={setProductAccessState}
              />
            </VStack>
          </DrawerBody>
          <DrawerFooter justifyContent='flex-end'>
            <ButtonGroup>
              <Button
                variant='ghost'
                onClick={handleCloseDrawer}
                isDisabled={isSubmitting}
                data-testid='add-apps-to-member-cancel-button'
              >
                Cancel
              </Button>
              <Button
                type='submit'
                variant='solid'
                isLoading={isSubmitting}
                isDisabled={isSubmitting || !productAccessState.length}
                data-testid='add-apps-to-member-submit-button'
              >
                Save
              </Button>
            </ButtonGroup>
          </DrawerFooter>
        </DrawerContent>
      </form>
    </Drawer>
  );
};
